import { render, staticRenderFns } from "./User-message.vue?vue&type=template&id=274cbd66&"
import script from "./User-message.vue?vue&type=script&lang=js&"
export * from "./User-message.vue?vue&type=script&lang=js&"
import style0 from "./User-message.vue?vue&type=style&index=0&id=274cbd66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports